var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.0001C20.355 19.0001 19 20.3551 19 22.0001V35.0001C19 36.1051 19.895 37.0001 21 37.0001H35C36.105 37.0001 37 36.1051 37 35.0001V25.0001C37 23.8951 36.105 23.0001 35 23.0001H24H22C21.435 23.0001 21 22.5651 21 22.0001C21 21.4351 21.435 21.0001 22 21.0001H35C35.1325 21.002 35.2641 20.9775 35.387 20.9281C35.51 20.8787 35.6219 20.8053 35.7163 20.7123C35.8107 20.6192 35.8856 20.5083 35.9368 20.3861C35.9879 20.2638 36.0142 20.1326 36.0142 20.0001C36.0142 19.8676 35.9879 19.7364 35.9368 19.6141C35.8856 19.4919 35.8107 19.381 35.7163 19.2879C35.6219 19.1949 35.51 19.1215 35.387 19.0721C35.2641 19.0227 35.1325 18.9982 35 19.0001H22ZM34 29.0001C34.552 29.0001 35 29.4481 35 30.0001C35 30.5521 34.552 31.0001 34 31.0001C33.448 31.0001 33 30.5521 33 30.0001C33 29.4481 33.448 29.0001 34 29.0001Z",
    fill: "#12171F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#E0E5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c97ee74e489768ade80829873e7ea397.svg";
export { ForwardRef as ReactComponent };